import React, { Component } from "react";
import { Modal, Tree, Spin } from "antd";

import { connect } from "dva";
import styles from "./index.less";

const { TreeNode } = Tree;

@connect(({ evaluateSetting }) => ({
  ...evaluateSetting
}))
class SelectPersonalNorm extends Component {
  constructor(props) {
    super(props);

    const { personalOrgList } = props;
    const tempData = [];
    if (personalOrgList && personalOrgList.length) {
      personalOrgList.forEach(item => {
        tempData.push({ ...item });
      });
      this.handleGetOrgTree(tempData[0] || {});
    }

    this.state = {
      selectedNormNode: [],
      personalOrgList: tempData,
      nowOrg: tempData[0] || {},
      orgIndexList: [],
      showTree: false
    };
  }

  // 获取组织学校对应的树
  handleGetOrgTree = org => {
    const { dispatch, currentProjectId, currentUserGroupId } = this.props;
    const { respondentOrgId } = org;
    if (respondentOrgId) {
      dispatch({
        type: "evaluateSetting/fetchNormTree",
        payload: {
          projectId: currentProjectId,
          userGroupId: currentUserGroupId,
          respondentOrgId
        },
        callback: () => {
          const { existedIndexCodeList } = this.props;
          const { orgIndexList } = this.state;
          // 判断当前的组织是不是已经被操作过，操作过就把选中的indexList更新为操作过的，否则更新为当前树的
          if (orgIndexList && orgIndexList.length) {
            if (
              orgIndexList.find(
                item => item.respondentOrgId === respondentOrgId
              )
            ) {
              orgIndexList.forEach(orgItem => {
                if (orgItem.respondentOrgId === respondentOrgId) {
                  this.setState({
                    selectedNormNode: orgItem.indexCodeList || [],
                    showTree: true
                  });
                }
              });
            } else {
              this.setState({
                selectedNormNode: existedIndexCodeList || [],
                showTree: true
              });
            }
          } else {
            this.setState({
              selectedNormNode: existedIndexCodeList || [],
              showTree: true
            });
          }
        }
      });
    }
  };

  handleOk = () => {
    const { onOk } = this.props;
    const { orgIndexList } = this.state;
    if (onOk) {
      onOk(orgIndexList);
    }
  };

  onCheck = checkedKeys => {
    const { personalOrgList, nowOrg, orgIndexList } = this.state;
    const tempCheckData = [];
    const tempOrgIndexList = [];

    // 处理学校勾选树的设置数量的逻辑
    personalOrgList.forEach(item => {
      if (item?.respondentOrgId === nowOrg?.respondentOrgId) {
        tempCheckData.push({ ...item, existedCount: checkedKeys?.length });
      } else {
        tempCheckData.push(item);
      }
    });

    // 处理不同学校勾选指标树的逻辑
    if (orgIndexList && orgIndexList.length) {
      orgIndexList.forEach(item => {
        tempOrgIndexList.push(item);
      });
    } else {
      tempOrgIndexList.push({
        indexCodeList: checkedKeys,
        respondentOrgId: nowOrg?.respondentOrgId
      });
    }

    const newTempOrgIndexList = tempOrgIndexList.filter(item => {
      return item?.respondentOrgId !== nowOrg?.respondentOrgId;
    });

    newTempOrgIndexList.push({
      indexCodeList: checkedKeys,
      respondentOrgId: nowOrg?.respondentOrgId
    });

    this.setState({
      selectedNormNode: checkedKeys,
      personalOrgList: tempCheckData,
      orgIndexList: newTempOrgIndexList
    });
  };

  onSelect = () => {
    console.log();
  };

  // 修改选中的学校的下标
  handleSetNowSchoolIndex = item => {
    this.setState(
      {
        nowOrg: item,
        showTree: false
      },
      () => {
        this.handleGetOrgTree(item);
      }
    );
  };

  renderTree = () => {
    const { tree } = this.props;
    const { selectedNormNode, showTree } = this.state;
    return (
      <div className="rightContainer">
        {showTree && (
          <Tree
            checkable
            onCheck={this.onCheck}
            onSelect={this.onSelect}
            checkedKeys={selectedNormNode}
            defaultExpandAll
          >
            {this.renderTreeNodes(tree)}
          </Tree>
        )}
      </div>
    );
  };

  // 左边学校部分
  renderLeft = () => {
    const { nowOrg, personalOrgList } = this.state;
    return (
      <div className="schoolContainer">
        {personalOrgList.length ? (
          personalOrgList?.map(item => {
            return (
              <div
                className={`schoolItem ${
                  nowOrg?.respondentOrgId === item?.respondentOrgId
                    ? "activeSchool"
                    : ""
                }`}
                onClick={() => this.handleSetNowSchoolIndex(item)}
              >
                {item?.respondentOrgName}
                <span style={{ color: "#1785ec" }}>
                  {item?.existedCount
                    ? `(已设置${item.existedCount}/${item.sum})`
                    : ""}
                </span>
              </div>
            );
          })
        ) : (
          <div className="modalNoData">暂无数据</div>
        )}
      </div>
    );
  };

  renderTreeNodes = data => {
    const { numberName, id, type } = data;
    return (
      <TreeNode
        title={numberName}
        key={id}
        treeNodeData={data}
        checkable={type === 2}
      >
        {(data.child || []).map(items => {
          return this.renderTreeNodes(items);
        })}
      </TreeNode>
    );
  };

  render() {
    const { nowOrg } = this.state;
    const { onCancel, spinProps, personalOrgList } = this.props;
    return (
      <Modal
        title="请选择个性化指标"
        visible
        centered
        onOk={this.handleOk}
        onCancel={() => onCancel()}
        wrapClassName={styles.normModal}
      >
        <Spin {...spinProps}>
          <div
            className={
              personalOrgList && personalOrgList.length
                ? "modal-body-wrap"
                : "modal-body-wrap modal-body-no-data"
            }
          >
            {this.renderLeft()}
            {nowOrg && nowOrg.respondentOrgId ? this.renderTree() : null}
          </div>
        </Spin>
      </Modal>
    );
  }
}

export default SelectPersonalNorm;
